import { Component, OnInit } from "@angular/core";
import { ButtonComponent } from "@components/button/button.component";
import { MsalService } from '@azure/msal-angular'
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'app-login-error',
    standalone: true,
    imports: [ButtonComponent, TranslateModule],
    templateUrl: './login-error.component.html',
    styleUrls: ['./login-error.component.scss'],
})
export class LoginErrorComponent implements OnInit {

    constructor(private authService: MsalService, private router: Router) {}

    ngOnInit(): void {
    }

    retryLogin(): void {
        localStorage.clear()
        sessionStorage.clear()
        this.authService.instance.logoutRedirect().then(() => {
            this.router.navigate(['home'])
        })
    }
}